module.exports = __webpack_public_path__ + "d610328d6aeb74e72145a609fa3ee300.cur";


//////////////////
// WEBPACK FOOTER
// ./app/assets/icons/cursors/circles/cur/circle-92.cur
// module id = 485
// module chunks = 0